<div class="default-padding" >
  <button fxLayoutGap="20px" mat-stroked-button routerLink="/dashboard">
    <mat-icon>keyboard_arrow_left</mat-icon>Back to Assessment</button>

</div>



<div class="page-container" fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
  <div class="assessment-container" *ngIf='activeAssessment !== null'>
    <!-- Assessment information -->
    <div class="assessment-information" fxLayout="column" fxLayoutAlign="start start">
      <h1 class="gtap-title" *ngIf="!!activeAssessment.name">
        {{ activeAssessment.name }}
      </h1>
      <span class="gtap-description" *ngIf="!!activeAssessment.description">{{
        activeAssessment.description
        }}</span>
    </div>
    <div class="assessment-time-left" *ngIf="activeAssessment.assessment_time_left">
      {{ activeAssessment.assessment_time_left }}
    </div>
    <div class="question-container">
      <div class="question-container-heading default-padding" fxLayout="row" fxLayoutAlign="start center">
        <h1 class="bolder no-margin">
          Question {{ currentQuestionNumber + 1 }} of
          {{ totalNumberOfQuestions }}
        </h1>
      </div>
      <div *ngIf="!pageLoading && !errorMessage" class="current-question-container">
        <div *ngIf="currentQuestion || !changingQuestion">
          <h3 class="question-label default-padding">
            {{ currentQuestion.question }}
            <span *ngIf='activeAssessment.is_external' class='external-msg'>
              Please <a [href]='activeAssessment.url' target='_blank' class='green-link'>Click Here</a> to start the assessment
            </span>
          </h3>
          <div class="question-choice">
            <div *ngIf="
                currentQuestion.has_options && currentQuestion.is_multi_answer
              ">
              <!-- here we need to the select all that applied -->
              <h4>Select all that apply</h4>
              <mat-select class="gtap-option">
                <mat-option *ngFor="let option of currentQuestion.options" [value]="option.value.value"
                  (change)="onOptionSelectedChanged($event)">{{ option.friendly }}</mat-option>
              </mat-select>
            </div>

            <!-- has option and single answer we need to used the radio -->
            <div *ngIf="
                currentQuestion.has_options && !currentQuestion.is_multi_answer
              ">
              <mat-radio-group (change)="onOptionSelectedChanged($event)" fxLayout="column" fxLayoutGap="10px"
                [value]="userAnswer | async">
                <mat-radio-button class="gtap-option" *ngFor="let option of currentQuestion.options"
                  [value]="option.value.value" fxFlex>{{ option.friendly }}</mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- Free answer -->
            <div *ngIf="
                !currentQuestion.has_options && !currentQuestion.is_multi_answer
              ">
              <mat-form-field fxFill>
                <mat-label class="g-label">Type your answer</mat-label>
                <textarea matInput placeholder="Type your answer" [value]="userAnswer | async"
                  (keyup)="onFreeAnswerChanged($event)" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxFlex fxLayoutAlign="space-between center" class="action-container">
    <div class="previous">
      <span class="hidden"></span>
      <button mat-raised-button (click)="previousQuestion()" *ngIf="currentQuestionNumber > 0" color="primary">
        <mat-icon>navigate_before</mat-icon>
        Prev
      </button>
    </div>
    <div class="next-button">
      <button mat-raised-button color="primary" (click)="nextQuestion()"
        *ngIf="currentQuestionNumber + 1 < totalNumberOfQuestions">
        Next
        <mat-icon>navigate_next</mat-icon>
      </button>
      <button mat-raised-button color="primary" (click)="submitAssessment()"
        *ngIf="currentQuestionNumber + 1 === totalNumberOfQuestions">
        Submit
      </button>
    </div>
  </div>
</div>
